import React from 'react'
// import InputField from '../components/InputField'
import InputField from '../../../sharedcomponents/1elements/Fields/InputField'
import { makeStyles } from '@material-ui/core/styles'
import UniversalAddress from '../../../sharedcomponents/2compounds/UniversalAddress'

const LeftChild = ({
  formikProps,
  editMode,
  createMode,
  entityTypes,
  industryTypes
}) => {
  const classes = useStyles()
  const values = formikProps.values

  return (
    <div className={classes.root}>
      <div className={classes.leftPanel}>
        <InputField
          type='text'
          name='name'
          maxLength={150}
          required={true}
          label='Entity Name'
          value={values?.name ?? ''}
          editMode={editMode}
        />
        <InputField
          type='textarea'
          name='description'
          maxLength={150}
          required={false}
          label='Description'
          value={values?.description ?? ''}
          editMode={editMode}
        />
        <InputField
          type='phone'
          name='phone'
          label='Phone Number'
          value={values?.phone ?? ''}
          values={values}
          setFieldValue={formikProps.setFieldValue}
          editMode={editMode}
        />
        <InputField
          type='select'
          name='type_id'
          maxLength={150}
          options={
            entityTypes &&
            entityTypes.map(oneOption => ({
              key: oneOption.id,
              value: oneOption.id,
              text: oneOption.name
            }))
          }
          label='Entity Type'
          value={values?.type_id ?? ''}
          editMode={editMode}
          setFieldValue={formikProps.setFieldValue}
        />
        <InputField
          type='select'
          name='industry_id'
          maxLength={150}
          options={
            industryTypes &&
            industryTypes.map(oneOption => ({
              key: oneOption.id,
              value: oneOption.id,
              text: oneOption.name
            }))
          }
          label='Industry Type'
          value={values?.industry_id ?? ''}
          editMode={editMode}
          setFieldValue={formikProps.setFieldValue}
        />
        <InputField
          type='url'
          name='url'
          required={false}
          maxLength={120}
          label='Other Link'
          value={values?.url ?? ''}
          editMode={editMode}
        />
      </div>
      <div className={classes.rightPanel}>
        <UniversalAddress
          values={formikProps.values}
          editMode={editMode}
          setFieldValue={formikProps.setFieldValue}
        />
      </div>
    </div>
  )
}

export default LeftChild

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& >*': {
      boxSizing: 'border-box'
    }
  },
  leftPanel: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px 0 0'
  },
  rightPanel: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 0 0 10px'
  }
}))
